import { useState } from 'react';

/**
 * Reads `prefers-reduced-motion` once, via a lazy initializer: the
 * preference cannot change while a component using it stays mounted, so
 * there is nothing to subscribe to. Shared by `Skeleton`, `Modal`, and
 * `ToastViewport` \u2014 three real consumers in this same PR chain.
 */
export function usePrefersReducedMotion(): boolean {
  const [prefersReducedMotion] = useState(
    () => window.matchMedia('(prefers-reduced-motion: reduce)').matches,
  );
  return prefersReducedMotion;
}
